import { Dimension, Units } from "@freightsimple/ui-core/Data/Units";
import { DimensionInput } from "@freightsimple/ui-core/Controls/DimensionInput";
import type { ErrorMessageType } from "@freightsimple/ui-core/FormLayout/FormItem";
import { claimsFieldWidth } from "../Helpers/claimsFieldWidth";
import type { Currency } from "@freightsimple/generated-dashboard-openapi-client/models/Currency";

interface CurrencyInputProps {
  dataTestId: string;
  label: string;
  /** Named in the label, so the amount can't be read in the wrong currency. */
  currency: Currency;
  value?: number | undefined;
  onChange: (value: number | undefined) => void;
  errorMessage: ErrorMessageType;
  forceValidation: boolean;
  placeholder?: string | undefined;
}

/**
 * A dollars-and-cents amount field, rounded to two decimal places.
 *
 * Built on `DimensionInput` because it is ui-core's only *optional* number
 * input — a blank field emits `undefined`, so validation can tell "not entered"
 * from a real 0. See `ClaimsPiecesInput` for the same note.
 */
export function ClaimsCurrencyInput(props: CurrencyInputProps) {
  return (
    <DimensionInput
      dataTestId={props.dataTestId}
      label={`${props.label} (${props.currency})`}
      value={props.value}
      onChange={function (newValue) {
        props.onChange(
          newValue === undefined ? undefined : parseFloat(newValue.toFixed(2)),
        );
      }}
      units={Units.Imperial}
      dimension={Dimension.Length}
      errorMessage={props.errorMessage}
      forceValidation={props.forceValidation}
      widthPx={claimsFieldWidth.px}
      placeholder={props.placeholder}
    />
  );
}
